module.exports = __webpack_public_path__ + "img/loading.5638e362.png";